/* ============================================================
   Valor Couture — Livraison assurée (verborgen product)
   - €3,95 wordt toegevoegd als echte (verborgen) winkelwagenregel,
     zodat het bedrag bij de checkout wordt afgerekend.
   - Standaard AAN zodra er producten in de winkelwagen zitten.
   - Klant kan uitzetten; keuze wordt onthouden (attribuut Assurance=Non),
     zodat de verzekering niet automatisch terugkomt.
   - Verborgen product: maak in Shopify een product met handle
     "livraison-assuree" en prijs 3,95. De regel wordt in de drawer
     verborgen en telt niet mee voor de staffelkorting.
   ============================================================ */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function refresh(state) {
    if (state && state.sections) {
      replaceSection('CartDrawer', state.sections['cart-drawer']);
      replaceSection('cart-icon-bubble', state.sections['cart-icon-bubble'], '.shopify-section');
    }
    document.dispatchEvent(new CustomEvent('valor:cart:updated'));
  }

  function replaceSection(id, html, selector) {
    if (!html) return;
    var target = document.getElementById(id);
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = selector ? doc.querySelector(selector) : doc.getElementById(id);
    if (source) target.innerHTML = source.innerHTML;
  }

  var SECTIONS = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };

  function setOptout(value) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ attributes: { Assurance: value } }, SECTIONS)),
    }).then(function (r) { return r.json(); });
  }

  function addInsurance(variantId) {
    // eerst opt-out wissen, daarna het product toevoegen
    return setOptout('Oui').then(function () {
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ items: [{ id: Number(variantId), quantity: 1 }] }, SECTIONS)),
      }).then(function (r) { return r.json(); });
    });
  }

  function removeInsurance(key) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ id: key, quantity: 0, attributes: { Assurance: 'Non' } }, SECTIONS)),
    }).then(function (r) { return r.json(); });
  }

  // Toggle wijzigen (delegated: de drawer wordt telkens opnieuw gerenderd)
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches('[data-valor-insurance-toggle]') || busy) return;
    var wrap = el.closest('[data-valor-insurance]');
    if (!wrap) return;
    busy = true;
    var done = function (state) { refresh(state); busy = false; };
    var fail = function () { busy = false; };
    if (el.checked) {
      addInsurance(wrap.getAttribute('data-ins-variant')).then(done).catch(fail);
    } else {
      removeInsurance(wrap.getAttribute('data-ins-key')).then(done).catch(fail);
    }
  });

  // Standaard AAN: items aanwezig, verzekering niet aanwezig, en niet handmatig uitgezet
  function ensureDefault() {
    if (busy) return;
    var wrap = document.querySelector('[data-valor-insurance]');
    if (!wrap) return;
    var present = wrap.getAttribute('data-ins-present') === 'true';
    var optout = wrap.getAttribute('data-ins-optout') === 'true';
    var variantId = wrap.getAttribute('data-ins-variant');
    if (!present && !optout && variantId) {
      busy = true;
      addInsurance(variantId)
        .then(function (state) { refresh(state); busy = false; })
        .catch(function () { busy = false; });
    }
  }

  document.addEventListener('DOMContentLoaded', ensureDefault);
  document.addEventListener('cart:refresh', ensureDefault);
  document.addEventListener('valor:cart:updated', ensureDefault);

  // Dawn stuurt geen DOM-event bij add-to-cart; observeer de drawer-re-render.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; ensureDefault(); }, 60);
  }
  function startObserver() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) { return setTimeout(startObserver, 500); }
    new MutationObserver(schedule).observe(cd, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', startObserver);
})();
